import {
    RESET_STATE, 
    SET_AUTH,
    SET_AUTH_PROPERTY,
    SET_PO_DATA,
    SET_ORDER_PROPERTY,
    SET_PO_TYPE,
    SET_PO_DATA_INFO,
    SET_PO_DATA_INFO_PROPERTY,
    SET_PO_APPROVED_CHECKED,
    SET_SELECT_ALL_TODAY_PO_CHECKED,
    SET_SELECT_INCOMPLETE_WEIGHING_PO_CHECKED,
    SET_SELECT_TODAYS,
    SET_PO_SUPPLIER_TYPE,
    SET_PO_DATA_APPROVED,
    SET_PO_SUPPLIER,
    SET_PO_RESTUARANT,
    SET_PO_FILTER_FIELDS,
    SET_PO_SEARCH_FIELDS,
    SET_PO_APPROVED_PAGINATION,
    SET_RL_SEARCH_FIELDS,
    SET_RL_PAGINATION,
    SET_I18N
} from '../constants/action-types';

import {
    UI,
    PRODUCT,
    INTERNAL,
    EXTERNAL,
    UNIT,
    UAT
  } from "../../constants/GlobalConstant";

import moment from 'moment';

const INITIAL_STATE = {
    auth: {
        mode:'',
        isLogin:false,
        token:'',
        businessId:0,
        operatorId:0,
        supplierId:0,
        isSupplier:false,
        erp:{},
        locale:null
    },
    order: {
        startDate: '',
        endDate: '',
    },
    unconfirmedDataPO:[],
    confirmedDataPO:[],
    receiptedDataPO:[],
    pendingDataPO:[],
    pendingDataPOInfo:[],
    poType:'',
    approvedDataPO:[],
    poApprovedChecked:[],

    selectAllTodayPO:false,
    selectIncompleteWeighingPO:false,
    selectTodays:'',
    poFilterWeighing:false,
    poSupplierType:INTERNAL,
    poSupplier:{supplierId: 'all', supplierName: 'All Internal Suppliers'},
    poRestuarant:0,
    branchProductMapping:false,
    poFilterFields: {
        weighing:false
    },
    poSearchFields: {
        searchDateType:"create",
        searchDate:moment().format('YYYY-MM-DD')
    },
    poApprovedPagination:1,
    rlSearchFields: {
        dateType:"",
        startDate:null,
        endDate:null
    },
    rlPagination:1,
    i18n:{}
};
  
const rootReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESET_STATE: {
            console.log('RESET STATE');
            let _state = JSON.parse(JSON.stringify(INITIAL_STATE));
            _state.auth.locale = state.auth.locale;
            return Object.assign({}, _state);
        }

        case SET_AUTH: {
            console.log('SET AUTH');
            let obj = JSON.parse(JSON.stringify(state.auth));
            obj.mode = action.payload.mode;
            obj.isLogin = action.payload.isLogin;
            obj.token = action.payload.token;
            obj.businessId = action.payload.businessId;
            obj.businessName = action.payload.businessName;
            obj.operatorId = action.payload.operatorId;
            obj.supplierId = action.payload.supplierId;
            obj.supplierName = action.payload.supplierName;
            obj.supplierNum = action.payload.supplierNum;
            obj.isSupplier = action.payload.isSupplier;
            obj.poApproval = action.payload.poApproval;
            obj.consolidation = action.payload.consolidation;
            obj.autoReceipt = action.payload.autoReceipt;
            obj.isInternalSupplier = action.payload.isInternalSupplier;
            obj.logisticsTable = action.payload.logisticsTable;
            obj.ui = action.payload.ui;
            obj.units = action.payload.units;
            obj.locale = action.payload.locale;
            if(action.payload.role) {
                obj.role = action.payload.role;
            }
            if(action.payload.erp) {
                obj.erp = action.payload.erp;
            }
            if(action.payload.supplierConfig) {
                obj.supplierConfig = action.payload.supplierConfig;
            }
            if(action.payload.suppliersConfig) {
                obj.suppliersConfig = action.payload.suppliersConfig;
            }
            if(action.payload.suppliersItestConfig) {
                obj.suppliersItestConfig = action.payload.suppliersItestConfig;
            }
            if(action.payload.suppliersUATConfig) {
                obj.suppliersUATConfig = action.payload.suppliersUATConfig;
            }
            if(action.payload.intervals) {
                obj.intervals = action.payload.intervals;
            }
            if(action.payload.operatorName) {
                obj.operatorName = action.payload.operatorName;
            }
            if(action.payload.supplierName) {
                obj.supplierName = action.payload.supplierName;
            }
            if(action.payload.branchProductMapping) {
                obj.branchProductMapping = true;
            }
            if(action.payload.isReceipt) {
                obj.isReceipt = true;
            }
 
            return Object.assign({}, state, {
                auth:obj
            });
        }

        case SET_AUTH_PROPERTY: {
            console.log('SET AUTH PROPERTY');
            let obj = JSON.parse(JSON.stringify(state.auth));
            obj[action.payload.prop] = action.payload.value;
 
            return Object.assign({}, state, {
                auth:obj
            });
        }

        case SET_PO_DATA: {
            console.log('SET PO DATA');
            let obj;
            if(action.payload.poType === "unconfirmed") {
                obj = {
                    "unconfirmedDataPO":action.payload.data
                };                
            } else {
                obj = {
                    "confirmedDataPO":action.payload.data
                };              }
            return Object.assign({}, state,obj);
        }

        case SET_ORDER_PROPERTY: {
            console.log('SET ORDER PROPERTY');
            let order = Object.assign({}, state.order);
            order[action.payload.prop] = action.payload.value;

            return Object.assign({}, state,{
                order:order
            });
        }

        case SET_PO_TYPE: {
            console.log('SET PO TYPE');

            return Object.assign({}, state,{
                poType:action.payload
            });
        }

        case SET_PO_DATA_INFO: {
            console.log('SET_PO_DATA_INFO');

            let supplierId = action.payload.supplierId;
            let data = action.payload.data;
      
            let poDataInfo = JSON.parse(JSON.stringify(state.pendingDataPOInfo));
            let index = poDataInfo.findIndex( item => item.supplierId === supplierId );

            if(index === -1) {
                let obj = {
                    supplierId:supplierId,
                    data:data
                }
                poDataInfo.push(obj);
            } else {
                let arr;

                if(action.payload.mode === "replace") {
                    arr = data;
                } else {
                    arr = [...poDataInfo[index].data, ...data];
                }
                
                arr = arr.filter((arr, index, self) =>
                index === self.findIndex((t) => (
                  t.GoodsId === arr.GoodsId && t.GoodsFormatId === arr.GoodsFormatId && t.DepId === arr.DepId
                )));
                           
                poDataInfo[index].data = arr;
            }

            return Object.assign({}, state,{
                pendingDataPOInfo:poDataInfo
            });   
        }

        case SET_PO_DATA_INFO_PROPERTY: {
            console.log('SET_PO_DATA_INFO_PROPERTY');
    
            let poDataInfo = JSON.parse(JSON.stringify(state.pendingDataPOInfo));
            let index = poDataInfo.findIndex( item => item.supplierId === action.payload.supplierId );
            let value = action.payload.value;
            if(!value) {
                value = 0;
            }

            if(index > -1) {
                let productIndex = poDataInfo[index].data.findIndex( (item) => item.GoodsId === action.payload.GoodsId && item.GoodsFormatId === action.payload.GoodsFormatId && item.DepId === action.payload.DepId);
                
                if(productIndex > -1) {
                    poDataInfo[index].data[productIndex][action.payload.prop] = value;            
                } 
            }
           
            return Object.assign({}, state,{
                pendingDataPOInfo:poDataInfo
            });  

        }

        case SET_PO_APPROVED_CHECKED: {
            console.log('SET PO APPROVED CHECKED');

            let array;
            if(action.payload === "reset") {
                array = [];
            } else {
                array = JSON.parse(JSON.stringify(state.poApprovedChecked));
                action.payload.forEach( (poId) => {
                    let index = array.indexOf(poId);
                    if(index > -1) {
                        array.splice(index, 1);
                    } else {
                        array.push(poId);
                    }
                });
            }

            return Object.assign({}, state,{
                poApprovedChecked:array
            });
        }

        case SET_SELECT_ALL_TODAY_PO_CHECKED: {
            console.log('SET_SELECT_ALL_TODAY_PO_CHECKED');
        
            return Object.assign({}, state,{
                selectAllTodayPO:action.payload
            });
        }

        case SET_SELECT_INCOMPLETE_WEIGHING_PO_CHECKED: {
            console.log('SET_SELECT_INCOMPLETE_WEIGHING_PO_CHECKED');
        
            return Object.assign({}, state,{
                selectIncompleteWeighingPO:action.payload
            });
        }

        case SET_SELECT_TODAYS: {
            console.log('SET_SELECT_TODAYS');
        
            return Object.assign({}, state,{
                selectTodays:action.payload
            });
        }

        case SET_PO_SUPPLIER_TYPE: {
            console.log('SET_PO_SUPPLIER_TYPE');
        
            return Object.assign({}, state,{
                poSupplierType:action.payload
            });
        }

        case SET_PO_DATA_APPROVED: {
            console.log('SET_PO_DATA_APPROVED');
            return Object.assign({}, state,{
                approvedDataPO:action.payload
            });
        }

        case SET_PO_SUPPLIER: {
            console.log('SET_PO_SUPPLIER');
        
            return Object.assign({}, state,{
                poSupplier:action.payload
            });
        }

        case SET_PO_RESTUARANT: {
            console.log('SET_PO_RESTUARANT');
        
            return Object.assign({}, state,{
                poRestuarant:parseInt(action.payload)
            });
        }

        case SET_PO_FILTER_FIELDS: {
            console.log('SET_PO_FILTER_FIELDS');

            let poFilterFields= JSON.parse(JSON.stringify(state.poFilterFields));

            if(action.payload.length > 0) {
                action.payload.forEach( (obj) => {
                    poFilterFields[obj.field] = obj.value;
                });
            } else {
                poFilterFields = {};
            }
            
            return Object.assign({}, state,{
                poFilterFields:poFilterFields
            });
        }

        case SET_PO_SEARCH_FIELDS: {
            console.log('SET_PO_SEARCH_FIELDS');

            let poSearchFields = JSON.parse(JSON.stringify(state.poSearchFields));
            poSearchFields[action.payload.field] = action.payload.value;

            return Object.assign({}, state,{
                poSearchFields:poSearchFields
            });
        }

        case SET_PO_APPROVED_PAGINATION: {
            console.log('SET_PO_APPROVED_PAGINATION');
            return Object.assign({}, state,{
                poApprovedPagination:action.payload
            });
        }

        case SET_RL_SEARCH_FIELDS: {
            console.log('SET_RL_SEARCH_FIELDS');

            let rlSearchFields = JSON.parse(JSON.stringify(state.rlSearchFields));

            action.payload.forEach( (obj) => {
                if(obj.value) {
                    rlSearchFields[obj.field] = obj.value;
                }
            });

            return Object.assign({}, state,{
                rlSearchFields:rlSearchFields
            });
        }

        case SET_RL_PAGINATION: {
            console.log('SET_RL_PAGINATION');
            return Object.assign({}, state,{
                rlPagination:action.payload
            });
        }

        case SET_I18N: {
            console.log('SET_I18N');
            let i18n = {};
            if (!('key' in state.i18n) && action.payload.property === UI) {
                if(Object.keys(state.i18n).length) {
                    i18n = JSON.parse(JSON.stringify(state.i18n));
                    Object.keys(action.payload.value).forEach( (locale) => {
                        i18n[locale][UI] = action.payload.value[locale][UI];
                    });
                } else {
                    i18n = action.payload.value;
                }
            } else {
                i18n = JSON.parse(JSON.stringify(state.i18n));
                for (const key in action.payload.value) {
                   i18n[key][action.payload.property] = action.payload.value[key][action.payload.property];
                }
            }

            return Object.assign({}, state,{
                i18n:i18n
            });
        }

        default:
            return state;
    
    }
  };
  
  export default rootReducer;